<wo-logout (login)="router.navigate(AppRoutingLinks.login())" />
